module.exports = __webpack_public_path__ + "static/media/add canteen category.31f4d9ca.svg";